// 3rd party
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class BudgetService {

  constructor(
    private http: Http
  ) { }

  get(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string): Observable<Response> {
    currentPage = currentPage || 1;

    return this.http
      .get('budgets/' + (identifier ? identifier : '') + '?fields=[]' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// ./src/app/budgets/shared/budget.service.ts